import { useRef, useState } from 'react';
import { Button } from 'src/components/atoms';
import { useOutsideClick } from 'src/hooks';
import { FormState } from 'src/types';
import {
  Container,
  DropdownChevronIcon,
  InnerContainer,
  SelectedCount,
} from './FilterSelect.styles';
import { FilterSelectDropDown } from './FilterSelectDropDown';

export type DropdownOptions = {
  label: string;
  value: string;
  checked: boolean;
};

interface DropdownProps {
  state: FormState;
}

export type OnChangeOption = (value: DropdownOptions[]) => void;

export type FilterSelectProps = {
  onChange: OnChangeOption;
  size: 'small' | 'medium' | 'large';
  'data-testid'?: string;
  $zIndex?: number;
  label?: string;
  options: DropdownOptions[];
  width?: string;
} & DropdownProps;

export const FilterSelect = (props: FilterSelectProps) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [numberOfSelected, setNumberOfSelected] = useState(0);

  const filterSelectContainerRef = useRef<HTMLDivElement>(null);
  useOutsideClick(filterSelectContainerRef, () => {
    if (menuIsOpen) {
      setMenuIsOpen(false);
    }
  });

  return (
    <Container
      ref={filterSelectContainerRef}
      data-testid={props['data-testid']}
      width={props.width}
    >
      <Button
        variant="secondary"
        size={props.size}
        disabled={props.state === FormState.DISABLED}
        width={props.width || 'auto'}
        justifyContent="space-between"
        onClick={() => {
          setMenuIsOpen(!menuIsOpen);
        }}
      >
        <InnerContainer>
          {props.label ?? 'Filter by'}
          <SelectedCount>({numberOfSelected})</SelectedCount>
        </InnerContainer>
        <DropdownChevronIcon
          $menuIsOpen={menuIsOpen}
          className="uil uil-angle-up"
        ></DropdownChevronIcon>
      </Button>
      <FilterSelectDropDown
        menuIsOpen={menuIsOpen}
        setNumberOfSelected={setNumberOfSelected}
        {...props}
      />
    </Container>
  );
};
